// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


function linkedIn(value) {
  let value$1 = value.trim();
  let profileUrl = /^(https?:\/\/)?(www\.)?linkedin\.com\/(in|company)\/[^\s/?#]+\/?([?#].*)?$/i;
  if (value$1 === "" || profileUrl.test(value$1)) {
    return {
      TAG: "Ok",
      _0: value$1
    };
  } else {
    return {
      TAG: "Error",
      _0: "Enter a LinkedIn profile or company URL, such as https://www.linkedin.com/in/your-name"
    };
  }
}

exports.linkedIn = linkedIn;
/* No side effect */
